module.exports = __webpack_public_path__ + "images/pages/for_business/sp/img02_c17e25ca3a447df13a88c41b5493ab43.png";